import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
    Box,
    Collapse,
    Divider,
    IconButton,
    Link,
    Typography,
} from '@mui/material';
import { useState } from 'react';

type FirefoxBlockPageProps = {
    title: string | React.ReactNode;
    stack?: string | React.ReactNode;
};

const FirefoxBlockPage = ({ title, stack }: FirefoxBlockPageProps) => {
    const [showStack, setShowStack] = useState(false);

    return (
        <Box
            height="100vh"
            width="100vw"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={1}
            >
                <Box display="flex" gap={2} alignItems="center">
                    <ErrorOutlineIcon color="error" sx={{ fontSize: 40 }} />
                    <Divider
                        orientation="vertical"
                        variant="middle"
                        flexItem
                        sx={{ height: 60 }}
                    />
                    <Typography width={300}>{title}</Typography>
                </Box>

                {stack && (
                    <Box width="100%" mt={2}>
                       <Box display="flex" justifyContent="center">
                            <IconButton
                                onClick={() => setShowStack(!showStack)}
                                size="small"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    px: 1.5,
                                }}
                            >
                                <Typography variant="body2" color="text.secondary">
                                    Technical Details
                                </Typography>
                                {showStack ? (
                                    <ExpandLessIcon fontSize="small" />
                                ) : (
                                    <ExpandMoreIcon fontSize="small" />
                                )}
                            </IconButton>
                        </Box>
                        <Collapse in={showStack}>
                            <Box
                                sx={(theme) => ({
                                    backgroundColor: theme.palette.action.hover,
                                    borderRadius: 1,
                                    p: 2,
                                    mt: 1,
                                    maxHeight: '200px',
                                    overflow: 'auto',
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-all',
                                })}
                            >
                                {stack}
                            </Box>
                        </Collapse>
                    </Box>
                )}

                <Box position="absolute" bottom={40} p={3} maxWidth={500}>
                    <Typography textAlign="center" variant="body2">
                        Please use a supported browser like{' '}
                        <strong>Chrome</strong>, <strong>Edge</strong>, or{' '}
                        <strong>Safari</strong>. For help, contact{' '}
                        <Link href="mailto:support@mvision.ai">
                            support@mvision.ai
                        </Link>
                        .
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default FirefoxBlockPage;
